/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ listingName: NonNullable<unknown> }} Confirmdeletelisting2Inputs */

const en_confirmdeletelisting2 = /** @type {(inputs: Confirmdeletelisting2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.listingName}"?`)
};

const de_confirmdeletelisting2 = /** @type {(inputs: Confirmdeletelisting2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willst du „${i?.listingName}“ wirklich löschen?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{listingName}\"?" |
*
* @param {Confirmdeletelisting2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmdeletelisting2 = /** @type {((inputs: Confirmdeletelisting2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmdeletelisting2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmdeletelisting2(inputs)
	return de_confirmdeletelisting2(inputs)
});
export { confirmdeletelisting2 as "confirmDeleteListing" }